import Logo from "components/Logo"
import Link from "next/link"
import Button from "components/Button"
import AvatarDropdown from "components/navbar/AvatarDropdown"

export default function DiscoverNavbar() {
  return (
    <div className="max-w-6xl px-4 mx-auto sm:px-6 lg:px-8">
      <div className="flex justify-between h-16">
        <div className="flex">
          <div className="flex items-center flex-shrink-0">
            <Link href={"/"} legacyBehavior>
              <div className="cursor-pointer">
                <Logo />
              </div>
            </Link>

            <span className="py-2 pl-5 ml-5 text-xl font-semibold text-gray-700 border-l-2 border-gray-200 hidden sm:block">
              Discover
            </span>
          </div>
        </div>
        <div className="flex items-center space-x-4">
          <Link href="/notes" legacyBehavior>
            <Button text="Create a new post" nonCustomizedColor={true} />
          </Link>

          <AvatarDropdown showExtraLinks />
        </div>
      </div>
    </div>
  )
}
